import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { EditorUserFacade, DataStoreFacade, UIFacade } from '../../../facades';
import { map } from 'rxjs/operators';
import { combineLatest } from 'rxjs';

@Component({
  selector: 'app-editor-user',
  templateUrl: './editor-user.component.html',
  styleUrls: ['./editor-user.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class EditorUserComponent {
  public form: FormGroup;
  public isRequesting = false;
  public options$ = combineLatest([
    this.dataStoreFacade.partners$,
    this.editorFacade.isReadOnly$,
  ]).pipe(
    map(([partners, isReadOnly]) => {
      return {
        partners,
        readOnly: isReadOnly,
      };
    })
  );

  constructor(
    public editorFacade: EditorUserFacade,
    private fb: FormBuilder,
    private dataStoreFacade: DataStoreFacade,
    public uiFacade: UIFacade
  ) {
    this.form = this.fb.group({});
  }
  onSubmit() {
    this.isRequesting = true;
    if (!this.form.invalid) {
      this.uiFacade.showLoading();
      this.editorFacade.save().subscribe(
        (result) => {
          if (result.success) {
            // SAVE SUCESS
            this.form.markAsUntouched();
            this.form.markAsPristine();
            this.isRequesting = false;
            this.uiFacade.hideLoading();
          }
        },
        (err) => {
          this.uiFacade.hideLoading();
        }
      );
    }
  }
  onClose() {
    this.editorFacade.close();
  }
}
